import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { trainerLibraryEntryState, type TrainerLibraryEntryState } from './trainerLegacyRoutes';

/**
 * Sends authenticated trainers from legacy `/exercises` or `/exercise/:id` to the hub Library.
 * Returns true while the redirect is pending (show a loader in the page).
 */
export function useTrainerLegacyExerciseRedirect(
  options: TrainerLibraryEntryState = {},
): boolean {
  const { profile, loading } = useAuth();
  const navigate = useNavigate();
  const isTrainer = profile?.role === 'trainer';
  const { viewExerciseId, editExerciseId, exerciseViewMode } = options;

  useEffect(() => {
    if (loading || !isTrainer) return;
    navigate('/trainer-dashboard', {
      replace: true,
      state: trainerLibraryEntryState({ viewExerciseId, editExerciseId, exerciseViewMode }),
    });
  }, [loading, isTrainer, navigate, viewExerciseId, editExerciseId, exerciseViewMode]);

  return !loading && isTrainer;
}
